export enum FormClientType {
  Applicant = "applicant",
  Beneficiary = "beneficiary",
  Petitioner = "petitioner",
  Sponsor = "sponsor",
}
